module.exports = __webpack_public_path__ + "img/gib.dce455a7.svg";